export enum RoleEnum {
    ADMINISTRATOR = 'administrator',
    ALDERMAN = 'alderman',
    DIRECTOR = 'director',
    ASSISTANT = 'assistant',
    SECRETARY = 'secretary',
    TEACHER = 'teacher',
    SUPERVISOR = 'supervisor',
    PARENT = 'parent',
    STUDENT = 'student',
    EMPLOYEE = 'employee',
    RELATIVE = 'relative',
    CONTACT = 'contact',
}
